import React from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { Check } from 'lucide-react';

import scss from './FormatPresetRow.module.scss';

const THUMB_SIZE = 26;

const getThumbStyle = ({ width, height }) => {
  const scale = THUMB_SIZE / Math.max(width, height);
  return { width: Math.max(6, Math.round(width * scale)), height: Math.max(6, Math.round(height * scale)) };
};

function FormatPresetRow({ preset, isActive, onSelect }) {
  const { t } = useTranslation('mediaStudio');

  return (
    <button
      type='button'
      className={clsx(scss.row, isActive && scss.rowActive)}
      aria-pressed={isActive}
      onClick={() => onSelect(preset)}>
      <span className={scss.thumb}>
        <span className={scss.thumbShape} style={getThumbStyle(preset)} />
      </span>
      <span className={scss.rowText}>
        <span className={scss.label}>{t(preset.labelKey)}</span>
        <span className={scss.meta}>
          {preset.width} × {preset.height}
        </span>
      </span>
      {isActive ? <Check size={16} className={scss.check} /> : <span className={scss.ratioTag}>{preset.ratio}</span>}
    </button>
  );
}

export default FormatPresetRow;
